import BranchContactMatchesHtml from './branch.contact-matches.html';

export function BranchContactsService (
  $uibModal,
  $q,
  workshopAPI 
) {

  var BranchContacts = function () {};

  BranchContacts.prototype.getMatches = function(type) {
    var self = this;

    switch (type) {
      case 'vendors':
        return workshopAPI.get('/branch_matching/find_all_vendor_matches');
      case 'customers':
      default:
        return workshopAPI.get('/branch_matching/find_all_customer_matches');
    }
  };

  BranchContacts.prototype.getMoreMatches = function(type, match) {
    var self = this;

    switch (type) {
      case 'vendors':
        return workshopAPI.get('/branch_matching/find_matches_for_vendor/'+ match.contact.id);
      case 'customers':
      default:
        return workshopAPI.get('/branch_matching/find_matches_for_customer/'+ match.contact.id);
    }
  };

  BranchContacts.prototype.saveMatches = function(type, matches) {
    var self = this;

    switch (type) {
      case 'vendors':
        return workshopAPI.post('/branch_matching/link_vendor_ids', { links: matches });
      case 'customers':
      default:
        return workshopAPI.post('/branch_matching/link_customer_ids', { links: matches });
    }
  };

  BranchContacts.prototype.viewMoreMatches = function(type, match) {
    var self = this;

    return $uibModal.open({
      controller: 'BranchContactMatchesCtrl',
      keyboard  : false,
      resolve   : {
        matches: function () {
          return self.getMoreMatches(type, match);
        }
      },
      templateUrl: BranchContactMatchesHtml,
      windowClass: 'lg-modal'
    }).result;
  };

  return BranchContacts;
}
